import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import LandingPageAppResource from './LandingPageAppResource';
import LandingPageHomeSectionAppResource from './LandingPageHomeSectionAppResource';

class LandingPageHomeBabyOrAdoptionAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-home-baby-or-adoption';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/homes/babies/or/adoptions';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'homeSectionUuid',
      'mainImageUuid',
      'backgroundFileUuid',
      'landingPage',
      'landingPageHome',
      'mainImage',
      'background',
      'hasMainImageBorder',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPage: LandingPageAppResource,
      landingPageHome: LandingPageHomeSectionAppResource,
      mainImage: FileAppResource,
      background: FileAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      landingPage: 'landing_page_uuid',
      landingPageHome: 'home_section_uuid',
      mainImage: 'main_image_uuid',
      background: 'background_file_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      landingPageUuid: {
        type: 'string',
        presence: true
      },
      homeSectionUuid: {
        type: 'string',
        presence: true
      },
      mainImageUuid: {
        type: 'string',
      },
      backgroundFileUuid: {
        type: 'string',
      },
      hasMainImageBorder: {
        type: 'boolean',
      },
    };
  }

}

export default LandingPageHomeBabyOrAdoptionAppResource;
